import type { ApolloError } from '@apollo/client'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import type { DocumentFieldErrors } from '../types/QueryInput'

const NO_FIELD_ERRORS: DocumentFieldErrors = []

/**
 * With `errorPolicy: 'all'` a response can carry both the document and GraphQL errors (a field resolver
 * rejected, e.g. a missing permission, so only that field is null). When the document came back, those
 * errors are field-level: the document renders and the errors are handed over as `fieldErrors`.
 * When there is no document, or the transport failed, the error stays a page-level `error`.
 */
export const splitDocumentError = ({
  document,
  error,
}: {
  document: unknown
  error?: ApolloError
}): { error?: ApolloError; fieldErrors: DocumentFieldErrors } => {
  const graphQLErrors = error?.graphQLErrors
  const isPartial = !isNil(document) && !error?.networkError && !isEmpty(graphQLErrors)

  return isPartial ? { error: undefined, fieldErrors: graphQLErrors } : { error, fieldErrors: NO_FIELD_ERRORS }
}
